/* unplugin-vue-components disabled */import { render } from "./goldenCard.vue?vue&type=template&id=41093569&scoped=true"
import script from "./goldenCard.vue?vue&type=script&lang=js"
export * from "./goldenCard.vue?vue&type=script&lang=js"

import "./goldenCard.vue?vue&type=style&index=0&id=41093569&scoped=true&lang=scss"
import "./goldenCard.vue?vue&type=style&index=1&id=41093569&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41093569"]])

export default __exports__